export default function useLayerListeners(layerInstance: LooseObject, listenerList: LayerListener[]) {
  listenerList.forEach((listener: LayerListener) => {
    layerInstance.on(listener.eventName, () => {
      listener.callbackList?.forEach((fn) => {
        fn?.();
      });
    });
  });
}
